import { render } from "./PlaceSuggestion.vue?vue&type=template&id=57321aa4"
import script from "./PlaceSuggestion.vue?vue&type=script&lang=js"
export * from "./PlaceSuggestion.vue?vue&type=script&lang=js"

import "./PlaceSuggestion.vue?vue&type=style&index=0&id=57321aa4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__